<template>
  <v-window-item value="breakdown">
    <v-card-text class="px-0">
      <v-data-table
          :headers="headers"
          :items="breakdownData"
          item-value="id"
          density="compact"
          hide-default-footer
          show-expand
      >
        <!-- Show expand icon only when details exist -->
        <template v-slot:item.data-table-expand="{ internalItem, isExpanded, toggleExpand }">

          <v-tooltip text="Product Breakdown" location="top" >
            <template v-slot:activator="{ props }">
              <v-btn
                  v-if="internalItem.raw.details?.length > 0"
                  icon
                  v-bind="props"
                  size="small"
                  variant="text"
                  @click="toggleExpand(internalItem)"
              >
                <v-icon>
                  {{ isExpanded(internalItem) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </template>

        <template v-slot:item.sl="{ index }">
          {{ index + 1 }}
        </template>

        <template v-slot:item.type="{ item }">
          <p class="px-2 text-left">{{ item.type }}</p>
        </template>

        <template v-slot:item.name="{ item }">
          <p class="px-2 text-left">{{ item.name }}</p>
        </template>

        <template v-slot:item.yearly_quantity="{ item }">
          <p class="px-2 text-end">
            {{ this.$numberFormat(item.yearly_quantity) }}
          </p>
        </template>

        <template v-slot:item.yearly_amount="{ item }">
          <p class="px-2 text-end">
            {{ this.$numberFormat(item.yearly_amount) }}
          </p>
        </template>

        <!-- Expanded row -->
        <template v-slot:expanded-row="{ item, columns }">
          <tr v-if="item.details?.length > 0">
            <td :colspan="columns.length">
              <v-card flat class="ma-2 pa-2 rounded" color="grey-lighten-4">
                <div class="text-subtitle-2 text-center">
                  Product Breakdown of
                  <span class="text-uppercase">
              {{ item.name }} {{ item.type }}
            </span>
                </div>

                <v-data-table
                    :headers="productHeaders"
                    :items="item.details"
                    item-value="id"
                    density="compact"
                    class="elevation-1 rounded"
                    hide-default-footer
                    :items-per-page="-1"
                >
                  <template v-slot:item.sl="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.product_code="{ item }">
                    <p class="text-left">{{ item.product_code }}</p>
                  </template>

                  <template v-slot:item.product_name="{ item }">
                    <p class="text-left px-2">{{ item.product_name }}</p>
                  </template>

                  <template v-slot:item.achieved_amount="{ item }">
                    <p class="text-end px-2">{{ this.$numberFormat(item.achieved_amount) }}</p>
                  </template>
                </v-data-table>
              </v-card>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-window-item>
</template>

<script>
export default {
  props: {
    breakdownData: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    headers: [
      { title: "SL", align: "center", key: "sl", width: "10%" },
      { title: "Type", key: "type", align: "center", sortable: false },
      { title: "Product Sub Category / Customer", align: "center", key: "name" },
      { title: "Yearly Quantity", align: "center", key: "yearly_quantity", },
      { title: "Yearly Amount", align: "center", key: "yearly_amount", },
    ],
    productHeaders: [
      { title: "SL", align: "center", key: "sl", width: "10%" },
      { title: "Product Code", align: "center", key: "product_code" },
      { title: "Product Name", align: "center", key: "product_name" },
      { title: "Achieved Amount", align: "center", key: "achieved_amount" },
    ],
  }),
};
</script>
